import { render, staticRenderFns } from "./SketchCanvas.vue?vue&type=template&id=b70c8454&scoped=true"
import script from "./SketchCanvas.vue?vue&type=script&lang=js"
export * from "./SketchCanvas.vue?vue&type=script&lang=js"
import style0 from "./SketchCanvas.vue?vue&type=style&index=0&id=b70c8454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70c8454",
  null
  
)

export default component.exports